<p-toast></p-toast>
<div class="crm-layout-wrapper" [class.side-panel-open]="claimSummaryOverlayVisible" [class.resizing]="isResizing">
  <div class="crm-panel" [style.margin-right.px]="claimSummaryOverlayVisible ? sidePanelWidth : 0" style="position: relative; box-shadow: 0 0 100px rgba(0,0,0,0.3);">
    <app-tab-spinner *ngIf="isLoading" [fixed]="true"></app-tab-spinner>
    <div class="crm-top">
      <div class="crm-panel__left">
        <service-order-form (formValueChanged)="setChangeData($event)"></service-order-form>
      </div>
      <div class="crm-panel__main" [appViewOnlyLock]="ssdViewOnly">
        <navigation-panel [navigationPanel]="navigationPanel"></navigation-panel>
      </div>
    </div>
    <div class="crm-bottom" *ngIf="componentDisplay">
      <div *ngIf="loadNote">
        <crm-notes
          *appSetRolePermissionsDirective="{type:'component', operation:'READ_ONLY', permission:'Notes', category: 'Claim'}"
          [parentCategory]="'Claim'" [category]="notesCategoryType" [identifierId]="identifierId"
          [disclaimer]="disclaimer" [disableAdd]="disclaimer" [viewOnly]="ssdViewOnly" [parentComponent]="component"
          [showSmartAgentAssist]="shouldShowClaimSummaryButton"
          [smartAgentAssistInProgress]="claimSummaryOverlayVisible"
          (smartAgentAssistClick)="openClaimSummaryPopup()"
          (dataRetrieved)="onNotesData($event)" #notesComponent>
        </crm-notes>
      </div>
    </div>
  </div>
  <!-- Right Side Panel for Claim Summary -->
  <div 
    class="claim-summary-side-panel" 
    *ngIf="claimSummaryOverlayVisible" 
    [@slideInOut]
    [style.width.px]="sidePanelWidth">
    <div 
      class="side-panel-resize-handle"
      (mousedown)="onResizeStart($event)">
    </div>
    <iframe
      class="side-panel-iframe"
      title="Claim summary details"
      [src]="claimSummaryIframeUrl">
    </iframe>
  </div>
</div>
<crm-alert-modal *ngIf="alertService.displayAlertModal" [modalTitle]="alertService.alertTitle"
  [modalContent]="alertService.alert && alertService.alert.message" [isBackgroundFreeze]="false"
  [(displayDialog)]="alertService.displayAlertModal" (displayDialogChange)="onAlertDisplayChange($event)">
</crm-alert-modal>
<p-dialog header="Proceed With Dispatch" [(visible)]="displayClaim" [style]="{width: '300px', height: 'auto'}">
  <div>Proceed With Dispatch</div>
</p-dialog>